"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useMapSize;

var _shallow = _interopRequireDefault(require("zustand/shallow"));

var _useMapStore = _interopRequireDefault(require("./useMapStore"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Provides pixel dimensions of the map viewport
 * @returns {[number, number]} [width, height]
 */
function useMapSize() {
  return (0, _useMapStore["default"])(function (state) {
    return [state.viewport.width, state.viewport.height];
  }, _shallow["default"]);
}